import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppLoadingService {
  private httpCount = 0;
  private manualCount = 0;

  private readonly loadingSubject = new BehaviorSubject(false);
  readonly loading$ = this.loadingSubject.asObservable();

  trackHttpStart(): void {
    this.httpCount++;
    this.sync();
  }

  trackHttpEnd(): void {
    this.httpCount = Math.max(0, this.httpCount - 1);
    this.sync();
  }

  /** Manual overlay (maps, graphs, etc.). */
  show(): void {
    this.manualCount++;
    this.sync();
  }

  hide(): void {
    this.manualCount = Math.max(0, this.manualCount - 1);
    this.sync();
  }

  private syncScheduled = false;

  /** Deferred to avoid NG0100 when HTTP starts during the same change-detection pass. */
  private sync(): void {
    if (this.syncScheduled) {
      return;
    }
    this.syncScheduled = true;
    queueMicrotask(() => {
      this.syncScheduled = false;
      const loading = this.httpCount + this.manualCount > 0;
      if (loading !== this.loadingSubject.value) {
        this.loadingSubject.next(loading);
      }
    });
  }
}
